module.exports = __webpack_public_path__ + "img/Row3Box2.5df8f663.svg";